import BuyPage from 'components/BuyPage/RwdBuy/BuyPage';
import { withBuyPageProps } from 'viewModel/buyPage/rwdBuy/withBuyPageProps';

export default withBuyPageProps(BuyPage);
